<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M0.5,802.5l-8.66-5v-10l8.66-5l8.66,5v10L0.5,802.5z M0.5,800.19l6.66-3.84v-7.69l-6.66-3.85l-6.66,3.85v7.69L0.5,800.19z
	 M5.5,791.5h-10v2h10V791.5z"/>
</svg>

</template>